<template>
    <div class="flex justify-content-end gap-2 mb-4 md:px-4">
        <Button label="New Notice" class="teal-button-small" @click="$emit('new-notice')" />
    </div>

    <div class="grid-container">
        <PlanLockOverlay v-for="(notice, index) in notices" :key="notice._id || index"
            :locked="!!notice.lockedByPlan" item-type="notice">
            <Card class="Card p-4 h-full">
                <template #content>
                    <div class="flex flex-column align-item-center justify-content-center gap-2 text-sm ">
                        <div class="flex justify-content-start gap-2 ">
                            <div class="flex flex-column justify-content-start gap-2 pb-2 w-full">

                                <span class="notice-title" :title="notice.title">{{ notice.title }}</span>

                                <span class="Paragraph-Medium">
                                    Created date - {{ formatToDisplayDate(notice.created_at) }}
                                </span>

                                <span class="status-badge"
                                    :class="notice.published ? 'status-published' : 'status-unpublished'">
                                    {{ notice.published ? 'Published' : 'Unpublished' }}
                                </span>

                                <span class="Label notice-text" v-html="notice.description"></span>
                            </div>
                        </div>
                    </div>
                </template>
                <template #footer>
                    <div class="flex justify-content-center gap-2 mt-3">
                        <Button label="View notice" class="teal-button-small" @click="$emit('view-notice', notice)" />
                    </div>
                </template>
            </Card>
        </PlanLockOverlay>
    </div>
</template>

<script setup>
import Card from "primevue/card";
import Button from "primevue/button";
import { defineProps, defineEmits } from "vue";
import { formatToDisplayDate } from "@/utils/cleanups";
import PlanLockOverlay from "@/components/PlanLockOverlay.vue";

defineProps({
    notices: {
        type: Array,
        required: true
    }
});

defineEmits(['view-notice', 'new-notice']);
</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
    /* grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr)); */
    gap: 3rem;
    padding: 0 1rem 1rem 1rem;
}

.Card {
    border-radius: 4px;
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.16);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.notice-title {
    font-size: 1.1rem;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: 0.3px;
    display: block;
    padding-bottom: 0.5rem;
    text-align: left;
    color: black;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.notice-text {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    min-height: 6em;
}

.status-badge {
    border-radius: 50px;
    padding: 2px 8px;
    font-weight: 600;
    font-size: 0.85rem;
    width: fit-content;
    background-color: transparent;
}

.status-published {
    color: #10b981;
    border: 1px solid #10b981;
}

.status-unpublished {
    color: #ef4444;
    border: 1px solid #ef4444;
}

.teal-button-small {
    padding: 8px 16px;
    height: 30px;
    font-size: 0.75rem;
}
</style>